import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EventNetworkingApiResponse } from '../types/event-networking.types';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private http: HttpClient) {}

  public getEventNetworking(eventId: string): Observable<EventNetworkingApiResponse> {
    return this.http.get<EventNetworkingApiResponse>(`${environment.apiUrl}/events/${eventId}/event_networking/`);
  }
}
